export const codelistUtils =(codelistData:any,codeListCode:any,codeListValueCode?:any)=>{
    const codelistCodeValues = codelistData && codelistData.length >0 ? codelistData?.find((item: any) => item[codeListCode]?.length > 0)?.[codeListCode] : {}
    let selectedValue = ''
    if(codeListValueCode){
        selectedValue = codelistCodeValues?.find((e:any)=>e['code_list_value_code']==codeListValueCode)?.['code_list_value']
    }
    return {codelistCodeValues,selectedValue}
}